"use client";
import { memo } from "react";
import CountdownBanner from "@/components/CountdownBanner";
import { FeatureFlagComponentResolverClient } from "@/lib/feature-flags/FeatureFlagResolverClient";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import { ProgramRedesignTrafficTestResult } from "@/monarch/rules/programRedesignTraffic/types";
import getSortedComponentsBySectionOrder, {
  ComponentItem,
} from "@/utils/getSortedComponentsBySectionOrder";

interface SideRailContentProps {
  headerComponentsOrder: string[];
  bodyComponentsOrder: string[];
  components: ComponentItem[];
}

function SideRailContent({
  headerComponentsOrder,
  bodyComponentsOrder,
  components,
}: SideRailContentProps) {
  return (
    <>
      <div className="flex flex-col gap-4 p-4 bg-putty-300 rounded-t-xl">
        <FeatureFlagComponentResolverClient
          flagKey="NEXT_PUBLIC_FEATURE_OC_COUNTDOWN_BANNER"
          variants={{
            test: (
              <MonarchDataConsumer<ProgramRedesignTrafficTestResult>
                experimentKey="useProgramRedesignTraffic"
                render={(testResult) => {
                  const countdownBanner = testResult?.data?.countdownBanner;
                  return (
                    <div className="md:hidden w-full md:w-auto">
                      <CountdownBanner
                        variant="micro"
                        theme={countdownBanner?.hero?.theme || "light"}
                        header={countdownBanner?.hero?.text || ""}
                        targetDate={countdownBanner?.hero?.date || ""}
                        htmlId="hero-program-promo-countdown-banner"
                        location="program-detail-page"
                        name="hero-program-promo-countdown-banner"
                      />
                    </div>
                  );
                }}
              />
            ),
            legacy: <></>,
          }}
          fallback="legacy"
        />
        {getSortedComponentsBySectionOrder({
          componentList: components,
          sectionsOrder: headerComponentsOrder,
        })}
      </div>
      <div className="flex flex-col gap-4 overflow-x-clip p-4 bg-gradient-to-b from-[#D7D3C5] to-putty-300 rounded-b-xl">
        {getSortedComponentsBySectionOrder({
          componentList: components,
          sectionsOrder: bodyComponentsOrder,
        })}
      </div>
    </>
  );
}

export default memo(SideRailContent);
